'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { mergeDismissedInsightImportIds, readDismissedInsightImportIds, writeDismissedInsightImportIds } from '../utils/insights-import-queue-dismissals-storage';
const listeners = new Set<() => void>();
function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
function emitChange() {
  for (const listener of listeners) {
    listener();
  }
}
export function useInsightsImportQueueDismissals() {
  const $ = _c(4);
  const [dismissedIds, setDismissedIds] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => subscribe(() => {
      setDismissedIds(readDismissedInsightImportIds());
    });
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const dismissIds = _temp2;
  const clearDismissals = _temp3;
  let t2;
  if ($[2] !== dismissedIds) {
    t2 = {
      dismissedIds,
      dismissIds,
      clearDismissals
    };
    $[2] = dismissedIds;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp3() {
  writeDismissedInsightImportIds(new Set());
  emitChange();
}
function _temp2(ids) {
  mergeDismissedInsightImportIds(ids);
  emitChange();
}
function _temp() {
  return readDismissedInsightImportIds();
}